import React from 'react';

export interface IDrawerContext {
  open(): void;
  close(): void;
}

export const DrawerContext = React.createContext<IDrawerContext>(null);


// WEBPACK FOOTER //
// ./src/components/Layout/Drawer/context.tsx